module.exports = ($stateProvider) => {
    $stateProvider
        .state('diagnostics', {
            abstract: true,
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('diagnostics');
                    },
                ],
            },
        })
        .state('diagnostics.styleguide', {
            url: '/styleguide',
            views: {
                '@': {
                    template: '<wow-styleguide></<wow-styleguide>',
                },
            },
        })
        .state('diagnostics.settings', {
            url: '/settingsdiagnostics',
            views: {
                '@': {
                    template: '<wow-missing-settings></wow-missing-settings>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/diagnostics.js